<template>
    <div>
        <el-form :model="from" :rules="rules" ref="ruleForm" label-width="170px">
            <table style="width: 95%; margin: 0 2%; margin-top: 20px;">
                <tr>
                    <td style="height: 30px; width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">社保编号：</span>
                            </template>
                            <el-input placeholder="请输入社保编号" v-model="from.social_security_no" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">医保编号：</span>
                            </template>
                            <el-input placeholder="请输入医保编号" v-model="from.medical_insurance_no" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">保险类别：</span>
                            </template>
                            <el-select v-model="from.insurance_type_ids" multiple
                                        collapse-tags placeholder="请选择保险类别" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in insuranceTypeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">五险参保开始月份：</span>
                            </template>
                            <el-date-picker v-model="from.insured_begin_date" type="month" placeholder="请选择五险参保开始月份"
                                style="width: 100%;" value-format="yyyy-MM" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">缴纳社保城市：</span>
                            </template>
                            <el-select v-model="from.insured_city" placeholder="请选择缴纳社保城市" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">缴费基数：</span>
                            </template>
                            <el-input type="number" placeholder="请输入缴费基数" v-model="from.payment_type" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item> 
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">雇主出险记录：</span>
                            </template>
                            <el-button plain size="mini"  @click="dangerStatus">出险记录</el-button>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">雇主出险状态：</span>
                            </template>
                            <el-input v-model="from.entry_type" size="small" disabled style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">是否缴纳公积金：</span>
                            </template>
                            <el-radio v-model="from.is_accumulation_fund" label="1">是</el-radio>
                            <el-radio v-model="from.is_accumulation_fund" label="0">否</el-radio>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">公积金编号：</span>
                            </template>
                            <el-input placeholder="请输入公积金编号" v-model="from.accumulation_fund_no" size="small"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">公积金基数：</span>
                            </template>
                            <el-input type="number" placeholder="请输入公积金基数" v-model="from.provident_fund_base" size="small"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>

                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">缴纳账户：</span>
                            </template>
                            <el-select v-model="from.payment_account" placeholder="请选择缴纳账户" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in PartnerList" :key="item.id" :label="item.partner_abbreviation"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">五险缴纳账户：</span>
                            </template>
                            <!-- <el-input placeholder="请输入五险缴纳账户" v-model="from.five_risks_account" size="small"
                                style="width: 100%;">
                            </el-input> -->
                            <el-select v-model="from.five_risks_account" placeholder="请选择五险缴纳账户" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in PartnerList" :key="item.id" :label="item.partner_abbreviation"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">养老三险基数：</span>
                            </template>
                            <el-input type="number" placeholder="请输入养老三险基数" v-model="from.aged_three_insurance" size="small"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">生育医疗保险基数：</span>
                            </template>
                            <el-input type="number" placeholder="请输入生育医疗保险基数" v-model="from.birth_insurance" size="small"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 50px; font-size: 16px;">是否扣医保大额：</span>
                            </template>
                            <el-select v-model="from.is_insurance_medical" placeholder="请选择缴纳月是否扣医保大额" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in medicalLevel" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">五险补差数额：</span>
                            </template>
                            <el-input type="number" placeholder="请输入五险补差数额" v-model="from.amount_making_difference" size="small"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">补差日期：</span>
                            </template>
                            <el-date-picker v-model="from.variance_makeup_date" type="month" placeholder="请选择补差日期"
                                style="width: 100%;" value-format="yyyy-MM" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                </tr>




            </table>
        </el-form>

        <el-dialog :title="出险记录" :visible.sync="dangerStatusType"
				width="30%" center="true" :close-on-click-modal="false">
            <el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                    :data="danger" tooltip-effect="dark" style="width: 100%" height="300">
                <el-table-column label="序号" width="50">
                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="danger_dete" label="出险时间" align="center"></el-table-column>
                <el-table-column prop="settlement_status" label="理赔情况" align="center"></el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 10px;">
                <el-button style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="dangerSavesp()">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        props: ["from"],
        data() {
            return {
                //保险类别
                insuranceTypeList: [],
                PartnerList:[],
                medicalLevel:[{
					value: '否',
					label: '否'
				}, {
					value: '按剩余月扣费',
					label: '按剩余月扣费'
				}, {
					value: '按年扣费',
					label: '按年扣费'
				}],
                dangerStatusType:false,
                danger:[],

            }
        },
        methods:{
            async dangerStatus(){
                debugger
                var url = "Danger/selectStaffAlls?staff_id=" + this.from.id;
				var data = await this.$globals.AxiosGet(url);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.danger = data;
						this.dangerStatusType = true
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
            },

            dangerSavesp(){
                this.dangerStatusType = false;
                this.danger = [];
            }

        },
        async created() {
            //初始化保险类别
            var insuranceTypeList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "insurance_type"
            });
            this.insuranceTypeList = insuranceTypeList.data;

            //初始化甲方名头管理
            var PartnerTypeList = await this.$globals.AxiosPost("partner/SelectAlls", {});
            this.PartnerList = PartnerTypeList.data;

        }
    }
</script>

<style scoped="scoped">
    >>>.el-button {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-button:hover {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-radio__input.is-checked .el-radio__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-radio__input.is-checked+.el-radio__label {
        color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// insurance.vue?45ff95bf